import { configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { combineReducers } from "redux";
import { FLUSH, PAUSE, PERSIST, persistReducer, PURGE, REGISTER, REHYDRATE } from "redux-persist";
import userSessionReducer from "../slices/userSession/userSessionSlice";
import adminTradeReducer from "../slices/adminTrade/adminTradeSlice";
import tempAssignmentReducer from "../slices/tempAssignment/tempAssignmentSlice";
import employeeTradeReducer from "../slices/employeeTrade/employeeTradeSlice";
import employeeTimeOffRequestReducer from "../slices/timeOffRequest/timeOffRequestSlice";
import adminTimeOffRequestReducer from "../slices/adminTimeOfRequest/adminTimeOfRequestSlice";
import adminTimeOffRequestWOPReducer from "../slices/adminTimeOfRequest/adminTimeOffRequestWOPSlice";
import adminBidReducer from "../slices/adminBid/adminBidSlice";
import employeeBidReducer from "../slices/employeeBid/employeeBidSlice";
import webSocketEventReducer from "../slices/webSocketEvent/webSocketEventSlice";
import techOpsUserSessionReducer from "../slices/techOpsUserSession/techOpsUserSession";
import commonConfigReducer from "../slices/commonConfig/commonConfigSlice";
import employeeTimeOffRequestWOPReducer from "../slices/timeOffRequest/employeeTimeOffRequestWOPSlice";
import employeeVoluntaryOTReducer from "../slices/employeeOvertime/employeeVoluntaryOTSlice";

const reducers = combineReducers({
  userSession: userSessionReducer,
  techOpsUserSession: techOpsUserSessionReducer,
  adminTrade: adminTradeReducer,
  tempAssignment: tempAssignmentReducer,
  employeeTrade: employeeTradeReducer,
  timeOffRequest: employeeTimeOffRequestReducer,
  employeeTimeOffRequestWOP: employeeTimeOffRequestWOPReducer,
  adminTimeOffRequestWOP: adminTimeOffRequestWOPReducer,
  adminTimeOffRequest: adminTimeOffRequestReducer,
  adminBid: adminBidReducer,
  employeeBid: employeeBidReducer,
  webSocketEvent: webSocketEventReducer,
  commonConfig: commonConfigReducer,
  employeeVoluntaryOT: employeeVoluntaryOTReducer,
});

const persistConfig = {
  key: "root",
  storage,
};

const persistedReducer = persistReducer(persistConfig, reducers);

export default configureStore({
  reducer: persistedReducer,
  // https://redux-toolkit.js.org/usage/usage-guide#use-with-redux-persist
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});
